import { Button } from '@quickmd-llc/design-system'
import { useCreateScriptlyOrder } from './useCreateScriptlyOrder'

type CreateScriptlyOrderButtonProps = {
  patientId: string
  orderId: string
  /** Visible text. A shorter label is for places where the surrounding context already says Scriptly. */
  label?: string
  /** Id of the element holding the reason the order is in its current state, such as a final failure. */
  describedBy?: string | undefined
}

const DEFAULT_LABEL = 'Create Scriptly order'

export function CreateScriptlyOrderButton({
  patientId,
  orderId,
  label = DEFAULT_LABEL,
  describedBy,
}: CreateScriptlyOrderButtonProps) {
  const { createScriptlyOrder, isCreatingScriptlyOrder } = useCreateScriptlyOrder()
  return (
    <Button
      priority='secondary'
      size='s'
      className='whitespace-nowrap'
      // A shorter label still names Scriptly, and the name starts with the visible text so speech
      // input ("click Create order") matches it.
      aria-label={label === DEFAULT_LABEL ? undefined : `${label} in Scriptly`}
      aria-describedby={describedBy}
      loading={isCreatingScriptlyOrder}
      onClick={() => createScriptlyOrder({ patientId, orderId })}>
      {label}
    </Button>
  )
}
